import { CashReceipt } from '@/fragments/orders';

export function AnonymousCashReceiptPage() {
  return <CashReceipt />;
}
